<script>
import Vue from 'vue'
import {mapActions} from 'vuex'
import {serverDateFormatter} from '../../utils/formatter'
import {COUNTRY_ARRIVO, IATA_ARRIVO, WS_URL} from '../../utils/config'
import {ERROR_GENERIC} from '../../utils/messages'
import ConfigUtils from '../utils/ConfigUtils'

export default {
  name: 'SearchTourAccompagnatiAction',
  mixins: [ConfigUtils],
  methods: {
    ...mapActions(['loadingStartWithSlider', 'loadingEndWithSlider']),
    searchTourAccompagnati (searchData) {
      this.loadingStartWithSlider()
      return new Promise((resolve, reject) => {
        const camere = searchData.camere.map(function (item, index) {
          return {id: index + 1, adults: item.adults, childs: item.childs}
        })
        let payload = {
          productId: searchData.productID,
          reparto: this.REPARTO_NAME,
          startDate: serverDateFormatter(this.$store.getters.isGiornoSuccessivoObbligatorio ? this.$moment(searchData.partenza).add(1, 'days').toDate() : searchData.partenza),
          travelGroup: camere
        }
        if (searchData.flight) {
          payload.flightRequest = this.makeFlight(searchData)
          payload.servizi = this.makeTrasferimenti()
        }
        Vue.axios.post(`${WS_URL}tour/record`, payload, {withCredentials: true}).then(response => {
          const data = response.data
          if (!data.done && data.messages) {
            const error = {error: true, messages: data.messages}
            this.$toastr.error(data.messages[0].message)
            reject(error)
          } else {
            resolve(response)
          }
        }).catch(error => {
          this.$toastr.error(ERROR_GENERIC)
          reject(error)
        }).finally(() => {
          this.loadingEndWithSlider()
        })
      })
    },
    makeFlight (searchData) {
      const voloGiornoSuccessivo = this.$store.getters.getVettori.voloGiornoSuccessivo
      const codiceHotelAlternativo = this.$store.getters.getVettori.codiceHotelAlternativo
      const vettori = this.$store.getters.getVettori.list.map(item => {
        return item.id
      })
      return {
        iataPartenza: searchData.aereoporto.value,
        iataArrivo: IATA_ARRIVO,
        startDate: searchData.partenza,
        endDate: searchData.ritorno,
        vettori: vettori,
        voloGiornoSuccessivo,
        codiceHotelAlternativo
      }
    },

    makeTrasferimenti () {
      return this.$store.getters.getServizi.list.filter(item => item.isTrasferimento).map(item => {
        return {countryCode: COUNTRY_ARRIVO, provider: item.fornitore.name, code: item.codice.trim()}
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/actions/SearchTourAccompagnatiAction.vue